export const normalizeDiscordId = (value) => {
  if (typeof value === 'number' && !Number.isSafeInteger(value)) return '';
  const raw = String(value ?? '').trim();
  if (!raw) return '';

  const mentionMatch = raw.match(/^<@!?(\d+)>$/);
  if (mentionMatch) return mentionMatch[1];
  if (/^\d{16,22}$/.test(raw)) return raw;
  return '';
};

export const formatDiscordMention = (value) => {
  const discordId = normalizeDiscordId(value);
  return discordId ? `<@${discordId}>` : '';
};
